/**
 * Append UTM parameters to a URL for outbound share / embed attribution.
 *
 * First-touch wins: if the URL already has a utm_source, the existing tags
 * are preserved and the new ones are ignored. Empty/invalid input is returned
 * unchanged.
 *
 * Example:
 *   withUtm("https://flash-grants.com/sponsor/abc", "share", "social", "sponsor_post")
 *   // → "https://flash-grants.com/sponsor/abc?utm_source=share&utm_medium=social&utm_campaign=sponsor_post"
 */
export function withUtm(url, source, medium, campaign) {
  if (!url || typeof url !== "string") return url;
  try {
    // URL parser needs an absolute URL; if it's a path, prefix it temporarily
    const isAbsolute = /^https?:\/\//i.test(url);
    const base = isAbsolute ? url : `https://_local${url.startsWith("/") ? "" : "/"}${url}`;
    const u = new URL(base);
    if (!u.searchParams.get("utm_source")) {
      u.searchParams.set("utm_source", source);
      u.searchParams.set("utm_medium", medium);
      u.searchParams.set("utm_campaign", campaign);
    }
    if (!isAbsolute) {
      return `${u.pathname}${u.search}${u.hash}`;
    }
    return u.toString();
  } catch {
    return url;
  }
}
